/**
 * 头像选中
 * @param props
 */
import { Select, SelectProps, SelectMultipleProps } from '@tencent/tea-component';
import { useMemo } from 'react';
import MemberOption, { MemberOptionProps } from '@tencent/tpm-meeting-active/lib/MemberOption';
import '@tencent/tpm-meeting-active/lib/MemberOption/style';
export interface Item extends MemberOptionProps {
  id: any;
  name?: any;
  tips?: any;
  imageUrl?: string;
}

export interface UserSelectProps extends SelectProps {
  data?: Array<Item>;
  selectedId?: any;
}

export interface UserMultiSelectProps extends SelectMultipleProps {
  data?: Array<Item>;
  selectedId?: any;
}
export const PeopleSelect = (props: UserSelectProps) => {
  const { data = [], selectedId, ...selectProps } = props;
  const options = useMemo(() => {
    if (!data || data?.length <= 0) return [];
    return data.map((x) => {
      if (Number(x.id) <= 0) {
        return {
          value: x.id,
          tooltip: x.tips || '',
          text: x.name,
        };
      }
      return {
        value: x.id,
        tooltip: x.tips || '',
        text: <MemberOption key={x.id} name={x.name} {...x} />,
      };
    });
  }, [data]);
  return (
    <Select
      className="ma-t-tag-dropdown"
      size="full"
      value={selectedId}
      options={options}
      {...selectProps}
    />
  );
};
export const PeopleMultiSelect = (props: UserMultiSelectProps) => {
  const { data = [], selectedId, ...selectProps } = props;
  const options = useMemo(() => {
    if (!data || data?.length <= 0) return [];
    return data.map((x) => {
      if (Number(x.id) <= 0) {
        return {
          value: x.id,
          tooltip: x.tips || '',
          text: x.name,
        };
      }
      return {
        value: x.id,
        tooltip: x.tips || '',
        text: <MemberOption key={x.id} name={x.name} />,
      };
    });
  }, [data]);

  return (
    <Select.Multiple
      className="ma-t-tag-dropdown"
      size="full"
      staging={false}
      value={selectedId}
      options={options}
      {...selectProps}
    />
  );
};
